export default __webpack_public_path__ + "static/media/campfire.2c3df777.jpg";